export const statusOptions: any[] = [
    { key: "all", text: "All" },
    { key: "true", text: "True" },
    { key: "false", text: "False" },
];